









































import { computed, defineComponent, PropType, toRefs } from '@vue/composition-api';
import TiktokTypeSelectItem from './item.vue';
import { TypeSelectItem, NativeIdentityType } from '../types';

const name = 'ttam-identity-tiktok-type-select';

export default defineComponent({
  name,
  components: { TiktokTypeSelectItem },
  props: {
    map: {
      type: Object as PropType<Record<NativeIdentityType, TypeSelectItem>>,
      default: () => ({}),
    },
    value: {
      type: String as PropType<NativeIdentityType>,
      default: NativeIdentityType.TIKTOK,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    showTiktok: {
      type: Boolean,
      default: true,
    },
    disableSwitch: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, { emit, slots }) {
    const { value, map } = toRefs(props);
    const { post: postSlot } = slots || {};

    const isSelectTiktok = computed(() => value.value === NativeIdentityType.TIKTOK);
    const onClick = (val: string) => {
      if (props.disableSwitch) {
        return;
      }
      emit('input', val);
      emit('select', map.value[val]);
    };

    return {
      name,
      isSelectTiktok,
      isHavePostSlot: Boolean(postSlot),
      NativeIdentityType,
      onClick,
    };
  },
});
